import { actions as kandyActions } from 'kandy-redux'
import * as types from '../constants/ActionTypes'
import api from '../utils/api'
import { agentLoggedOut } from '../socketEvents'
import {
    removeUserAccessToken,
    removeKandyUAT,
    setKandyUserName,
    setKandyPassword,
    removeKandyUserName,
    removeKandyPassword,
    setAgentUserType,
    getAgentUserType,
    removeAgentUserType
} from '../utils/auth'
import EventBus from '../components/eventBus';
/**
 * Used to authenticate the credentials of the agent logging in with the database
 * and then dispatches agentLoginFinish to set the KANDY UAT into local  storage token
 * @param {String} username - The username of the agent logging into the site
 * @param {String} password - The password of the agent logging into the site
 */
let agentLogin = (companyId, loginName, password, flag) => {
    return dispatch => {
        dispatch({ type: types.START_LOGIN })
        return api('/' + companyId + '/login')
            .post({ loginName, password, flag })
            .then(response =>
                {

                    if (response.errCode===0) {
                        const userAccessToken=response.result.userAccessToken

                        window.accessToken=userAccessToken
                    }
                  
                    dispatch(agentLoginFinish(response))
                }
            )
            .catch(err => {
                if (!err.response)
                    dispatch(agentLoginFinish({ errCode: -1, error: 'Failed to connect' }))
                else {
                    err.response.json()
                        .then(data => dispatch(agentLoginFinish(data)))
                        .catch(e => dispatch(agentLoginFinish({ errCode: -1, error: 'Could not login' })))
                }
            })
    }
}

let agentLogout = (companyId, fullUserId) => {

    return dispatch => {

        let userType = getAgentUserType()
        if (userType == 10) {
            removeAgentUserType();
            removeUserAccessToken();
            api('/' + (companyId ? companyId :'fastclaim')+ '/logout').post({ fullUserId, userType }).then(() => {
                EventBus.emit('logout', '/login');
                dispatch({
                    type: types.GET_AGENT_FINISH,
                    payload: {
                        agent: {
                            agentRole: {

                            },
                            tenant: {
                                statisticsMenus: [],
                                manualOptPermissions: [],
                                riskContrMod: {
                                    riskMarks: []
                                }
                            }
                        }
                    }
                })
            })
        } else {
            return api('/' + companyId + '/logout')
                .post({ fullUserId })
                .then(response => dispatch(agentLogoutFinish(response, fullUserId, companyId)))
                .catch(err => {
                    dispatch(agentLogoutFinish({ errCode: 0 }, fullUserId, companyId))
                })
        }

    }
};

/**
 * LOGIN_FINISH action
 * Used to indicate the agent login to the database has finished.
 * Initiates the user login to Kandy.
 * @param {Object} response The response object of the agent login request.
 */
let agentLoginFinish = (response) => {
    if (response.errCode == 0) {
        const userAccessToken = response.result.userAccessToken
        window.accessToken = userAccessToken
        if (response.result.userType === 10) {
            setAgentUserType(response.result.userType);
            return dispatch => {
                dispatch({
                    type: types.GET_AGENT_FINISH,
                    payload: {
                        agent: response.result
                    }
                })
            }
        } else {
            setKandyUserName(response.result.username)
            setKandyPassword((response.result.password))
            return dispatch => {
                dispatch({
                    type: 'USER_LOGIN_FINISH',
                    payload: response.result
                })
                dispatch(kandyActions.login(response.result.username, response.result.password))

                //Send the UAT to iOS device
                setupWebViewJavascriptBridge(bridge => {
                    bridge.callHandler('userDidLogin', { userAccessToken: response.result.userAccessToken }, response => {
                    })
                })
            }
        }
    } else {
        return {
            type: 'USER_LOGIN_FINISH',
            payload: response,
            error: true
        }
    }
}

let agentLogoutFinish = (response, fullUserId, companyId) => {

    if (response.errCode == 0) {
        removeUserAccessToken();
        removeKandyUAT();
        removeKandyUserName();
        removeKandyPassword();
        // Socket event to notify server
        agentLoggedOut(fullUserId, companyId)
        return dispatch => {
            EventBus.emit('logout', '/login');
            dispatch(kandyActions.logout())
            dispatch({
                type: types.GET_AGENT_FINISH,
                payload: {
                    agent: {}
                }
            })
        }
    } else if (response.errCode === 513) {
        removeUserAccessToken();
        removeKandyUAT();
        removeKandyUserName();
        removeKandyPassword();
        return dispatch => {
            EventBus.emit('logout', '/login');
            dispatch(kandyActions.logout())
            dispatch({
                type: types.GET_AGENT_FINISH,
                payload: {
                    agent: {}
                }
            })
        }

    }
}

/**
 * GET_AGENT action
 * Used to fetch details of an agent
 * @param {String} fullUserId - The fullUserId of the agent to fetch info for
 */
let getAgent = (fullUserId) => {
    var url = '/agents/' + fullUserId

    return dispatch => {
        dispatch(getAgentInitiate())
        return api(url).get()
            .then(agent => dispatch(getAgentFinish(agent)))
            .catch(err => {
                dispatch(getAgentFinish({ errCode: -1 }))
            })
    }
}

/**
 * Initiates GET_AGENT action.
 */
let getAgentInitiate = () => {
    return {
        type: types.GET_AGENT,
        payload: {}
    }
}

/**
 * GET_AGENT_FINISH action
 * Dispatched when the user details are fetched
 * @param {Object} agent - The agent object that is fetched
 */
let getAgentFinish = (agent) => {
    if (agent.errCode == 0) {
        return {
            type: types.GET_AGENT_FINISH,
            payload: {
                agent: agent.result
            }
        }
    } else {
        return {
            type: types.GET_AGENT_FINISH,
            payload: {},
            error: true
        }
    }
}



let sendCallDetails = (callee, callType) => {
    return dispatch => {
        setupWebViewJavascriptBridge(bridge => {
            bridge.callHandler('didTapCallButton', { callee, callType })
        })
    }
}

let getAgentList = (companyId) => {
    var url = '/' + companyId + '/agents/'

    return dispatch => {
        dispatch(getAgentListInitiate())
        return api(url).get()
            .then(agents => dispatch(getAgentListFinish(agents)))
            .catch(err => {
                dispatch(getAgentListFinish({ errCode: -1 }))
            })
    }
}

let getAgentListInitiate = () => {
    return {
        type: types.GET_AGENTLIST,
        payload: {}
    }
}

let getAgentListFinish = (agents) => {
    if (agents.errCode == 0) {
        return {
            type: types.GET_AGENTLIST_FINISH,
            payload: {
                agents: agents.result
            }
        }
    } else {
        return {
            type: types.GET_AGENTLIST_FINISH,
            payload: {},
            error: true
        }
    }
}


let updateAgentLoginState = (fullUserId, online) => {
    return {
        type: types.UPDATE_AGENT_LOGIN_STATE,
        payload: { fullUserId, online }
    }
}

let updateAgentServiceStatus = (agentId, service) => {
    return {
        type: types.UPDATE_AGENT_SERVICE_STATUS,
        payload: { agentId, service }
    }
}

let updateCurrentAgentState = (fullUserId, companyId, stateCode) => {


    return dispatch => {
        //set AgentState
        dispatch(currentAgentStateFinish(stateCode))

    }
}

let currentAgentStateFinish = (stateCode) => {
    return {
        type: types.UPDATE_CURRENTAGENT_STATE,
        payload: {
            stateCode
        }
    }


}
let updateCurrentAgentLoginState = (isLoggedIn) => {
    return dispatch => {
        dispatch(updateCurrentAgentLoginStateFinish(isLoggedIn))
    }
}
let updateCurrentAgentLoginStateFinish = (isLoggedIn) => {
    return {
        type: types.UPDATE_CURRENTAGENT_LOGIN_STATE,
        payload: {
            isLoggedIn
        }
    }
}

let setAgentKandyStatus = (status) => {
    return {
        type: types.UPDATE_AGENT_KANDY_STATUS,
        payload: { status }
    }
}
let setAgentServiceStatus = (UID, Status) => {
    return dispatch => {
        return api('/agent_service_status')
            .put({
                agentId: UID,
                status: Status
            })
            .then(response => dispatch(setAgentServiceStatusFinish(response, Status)))
            .catch(err => {
                dispatch(setAgentServiceStatusFinish({ errCode: -1 }))
            })
    }
}
let setAgentServiceStatusFinish = (response, Status) => {
    if (response.errCode == 0) {
        return {
            type: types.SET_AGENT_SERVICE_STATUS_FINISH,
            payload: Status,
        }
    } else {
        return {
            type: types.SET_AGENT_SERVICE_STATUS_FINISH,
            payload: {},
            error: true
        }
    }
}

export default {
    getAgent,
    updateCurrentAgentState,
    updateCurrentAgentLoginState,
    agentLogin,
    sendCallDetails,
    getAgentList,
    agentLogout,
    agentLoginFinish,
    updateAgentLoginState,
    updateAgentServiceStatus,
    setAgentKandyStatus,
    setAgentServiceStatus
    
}

